import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'recovery-frontend';
  private subscriptions: Subscription[] = [];

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    // Set the initial language settings
    const currentLang = this.translateService.currentLang || 'en';
    document.documentElement.lang = currentLang;
    document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr';

    // Subscribe to language change events
    const langSub = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        const lang = event.lang;
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      }
    );

    this.subscriptions.push(langSub);
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}